<template>

  <div class="main-div roster-result"
       v-bind:class="{ 'bottom-left': !showDetail && (!displayPdChart || !isRosterRoute), 'with-chat': activeStoreUsers.length > 1, 'middle-left': !showDetail && displayPdChart && isRosterRoute, 'top-left': showDetail }"
       v-if="(isWorking || (isRosterRoute)) ">

    <button class="square-button symbol-button" v-if="!showDetail" @click="showDetail = !showDetail">
      <i class="cog-icon fa-2x" v-bind:class="{'fas fa-cog fa-spin': isWorking, 'fas fa-cog': !isWorking}"></i>
    </button>
    <div v-if="showDetail" class="md-card">
      <div class="md-card-header">
        <h6 style="color: var(--contrast-0)">{{ $t('roster.comp.autoResult') }}<i class="fas fa-times"
           style=" color: var(--contrast-0); float: right"
           @click="showDetail = !showDetail"></i></h6>
      </div>
      <div class="md-card-body">
        <datatablesimple :state="dataTableSimpleState" :rowSelect="true" @row-select="onRowSelect"></datatablesimple>
      </div>
    </div>
  </div>

</template>

<script>
import VueEventBus from '../../vue-event-bus';

import { mapState, mapGetters } from 'vuex';
export default {
    name: 'rosterresult',
    components: {
    },
    data () {
        return {
            windowHeight: window.innerHeight,
            rosterOptions: [],
            ruleProfileMap: {},
            showDetail: false,
            rosterFields: [{key:"creationDate", label:this.$t('roster.main.planDate'), sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"from", label: this.$t('global.general.from'), sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"to", label:this.$t('global.general.to'), sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key: "ruleProfileLabel", label: "Regel Profil", thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key: "runtimeLabel", label: this.$t('roster.main.runtime'), thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"state", label: this.$t('global.general.status'), sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"unassignedShifts", label:this.$t('store.settings.shifts'), sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key: "actions", label: "", thClass: 'documentsTh', tdClass: 'documentsTd'}],
            selectedRosterId: null,
            spotMap: {},
            shiftMap: {},
            employeeMap: {},
            rosterResultMap: {},
            rosterResult: {},
            updateableShiftIds: [],
            error: false,
            errorMsg: "",
            timerId: null,
            loading: false,
            iconMap: ['fas fa-cog fa-spin', 'fas fa-cog fa-spin', 'fas fa-check', 'fas fa-times', 'fas fa-clock'],
        }
    },
    computed: {
        ...mapGetters(['rosterView', 'displayPdChart', 'activeStoreUsersMap', 'storeSettings']),
        activeStoreUsers(){
            return Object.values(this.activeStoreUsersMap).filter(u => u !== undefined);
        },
        loginStatus() {
            return this.$store.state.loggedIn;
        },
        rosterResultFromTo() {
            if(this.$store.state.loggedIn){
                return this.$store.state.rosterFromTo;
            } else {
                return null;
            }
        },
        rosterResultCreationDateMap() {
            let map = {};
            Object.values(this.rosterResultMap).forEach(r => {
                let date = this.$helpers.getMomentFromStringTZ(r.creationDate);
                map[r.id] = date;
            });
            return map;
        },
        detailHeight() {
                return (this.windowHeight-112)*0.6+'px';
        },
        storeId() {
                return this.$store.state.storeId;
        },
        stateLabel() {
               if(this.selectedRosterId){
                   let state = this.rosterResultMap[this.selectedRosterId].state;
                   if(state === 0 || state === 1){
                        return this.$t('roster.main.inProgress');
                    }
                    if(state === 2 ){
                        return this.$t('roster.main.finished');
                    }
                    if(state === 3 ){
                        return this.$t('roster.main.failed');
                    }
                    if(state === 4 ){
                        return this.$t('roster.main.stopped');
                    }
                    return null;
               } else {
                   return null;
               }
        },
        isRosterRoute() {
            return this.$route.name == "planning" && this.rosterView;
        },
        isWorking() {
            let isWorking = false;
            for(let resultId in this.rosterResultMap){
                if(this.rosterResultMap[resultId].state === 0 || this.rosterResultMap[resultId].state === 1){
                    isWorking = true;
                    break;
                }
            }
            return isWorking;
        },
        dataTableSimpleState() {
            let view = this;

            let state = {
                headerMap: [],
            };

            let columns = {
                creationDate: this.$t('roster.main.planDate'),
                from: this.$t('global.general.from'),
                to: this.$t('global.general.to'),
                ruleProfileId: this.$t('roster.comp.ruleProfile'),
                runtime: this.$t('roster.main.runtime'),
                stateVal: this.$t('global.general.status'),
                unassignedShifts: this.$t('roster.main.shift'),
                actions: " "
            };

            let data = Object.values(this.rosterOptions);

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDate')
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'from')
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'to')
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'ruleProfileId')
            state.headerMap.ruleProfileId.componentStateBuilders = [(data) => {
                return {
                    componentType: 'labelc',
                    state: {
                        text: this.ruleProfileMap[data.ruleProfileId].labelDe,
                    },
                    styleLabel: view.$helpers.styleLabel,
                }
            }];
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'runtime', 'min')
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'stateVal')
            state.headerMap.stateVal.componentStateBuilders = [(data) => {
                return {
                    componentType: 'buttonc',
                    disabled: false,
                    type: 'button icon-overlay square',
                    icon: this.iconMap[data.state.val],
                }
            }];

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'unassignedShifts')

            // Actions
            state.headerMap.actions.stylesEntry = {'justify-content': 'left'};
            state.headerMap.actions.componentStateBuilders = [
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('roster.main.watchPlanning')
                        },
                        type: 'button icon-overlay square',
                        icon: "fas fa-eye",
                        styleButton: {margin: '0 2px 0 2px'},
                        hideInput: !this.isRosterRoute || this.selectedRosterId !== data.id,
                        customEvents: {
                            click: () => {
                                view.loadRosterResultPreview();
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('roster.main.acceptPlanningResult')
                        },
                        type: 'button icon-overlay square',
                        icon: "fas fa-arrow-alt-circle-up",
                        styleButton: {margin: '0 2px 0 2px'},
                        hideInput: !this.isRosterRoute || this.selectedRosterId !== data.id ||
                            this.rosterResult.id !== this.selectedRosterId,
                        customEvents: {
                            click: () => {
                                view.applyRosterResult();
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('roster.main.stopPlanning')
                        },
                        type: 'button icon-overlay square',
                        icon: "fas fa-stop-circle",
                        styleButton: {margin: '0 2px 0 2px'},
                        hideInput: this.selectedRosterId !== data.id ||
                            !(this.rosterResultMap[this.selectedRosterId].state === 0 || this.rosterResultMap[this.selectedRosterId].state === 1),
                        customEvents: {
                            click: ($event) => {
                                view.openStopPlaningModal($event);
                            }
                        }
                    }
                },
                (data) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return this.$t('roster.main.deletePlanning')
                        },
                        type: 'button icon-overlay square',
                        icon: "fas fa-trash",
                        styleButton: {margin: '0 2px 0 2px'},
                        hideInput: this.selectedRosterId !== data.id ||
                            !(this.rosterResultMap[this.selectedRosterId].state === 2 ||
                                this.rosterResultMap[this.selectedRosterId].state === 3 ||
                                this.rosterResultMap[this.selectedRosterId].state === 4),
                        customEvents: {
                            click: ($event) => {
                                view.openDeletePlaningModal($event);
                            }
                        }
                    }
                },
            ];

            let entries = Object.entries(state.headerMap);

            let nameColumns = ['creationDate'];
            let nameColumnWidth = 24;
            let mainColumns = ['ruleProfileId', 'actions', 'runtime'];
            let mainColumnWidth = 12;
            let actionColumns = ['from', 'to', 'stateVal', 'unassignedShifts'];
            let actionColumnWidth = 10;
            for (let x in entries) {
                if (nameColumns.includes(entries[x][0])) {
                    entries[x][1].width = nameColumnWidth + '%';
                } else if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = {fontSize: '12px', position: "sticky", top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {background: '#6d8d23'};
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.sumRowStyles = {background: 'var(--sub-menu)'}
            state.alwaysUnfold = false;
            return state;
        }
    },
  watch: {
    rosterResultFromTo(newVal, oldVal) {
      if (newVal != null) {

        if (this.isRosterRoute) {
          this.loadRosters();
        }
      }
    },
    storeId(newVal, oldVal) {
      this.loadRosters();
    },
  },
  created: function () {
    //listen to vue eventbus for events from wizard and from vertx eventbus
    VueEventBus.$on("autoscheduling-submitted", this.reloadRosterResultListener);
    VueEventBus.$on("rosterResult-ready", this.eventBusRosterResultCallback);
    document.addEventListener('keydown', this.EscapeHandler);

  },
  mounted: function () {

    if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && this.$store.state.rosterFromTo != null){
            this.loadRosters();
            let view = this;
            this.loadRuleProfiles()
            .then(response=> {
                view.updateRuleProfiles(response.data);
            }).catch(error => {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            });
        }
        window.addEventListener('resize', this.onResizeWindow);
        this.timerId = window.setTimeout(() => {this.checkRosterFinish();}, 20*1000);
    },
    beforeDestroy() {
        VueEventBus.$off("autoscheduling-submitted", this.reloadRosterResultListener);
        VueEventBus.$off("rosterResult-ready", this.eventBusRosterResultCallback);
        window.removeEventListener('resize', this.onResizeWindow);
        window.clearTimeout(this.timerId);

        document.removeEventListener('keydown', this.EscapeHandler);
    },
  // methods that implement data logic.
  methods: {
    openDeletePlaningModal($event) {
      let view = this;

      view.$helpers.OpenPopup({
        elRelative: $event.currentTarget,
        type: 'datafill',
        componentState: {
          entries: [],
          description: this.$t('roster.main.deleteResultQuery'),
          selectCallback: function () {
            view.deleteRoster();
          }
        },
        header: this.$t('roster.main.deletePlanResult'),
        centered: true,
        expanded: true,
      });
    },
    openStopPlaningModal($event) {
      let view = this;

      view.$helpers.OpenPopup({
        elRelative: $event.currentTarget,
        type: 'datafill',
        componentState: {
          entries: [],
          description: this.$t('roster.main.stopPlanningQuery'),
          selectCallback: function () {
            view.stopRoster();
          }
        },
        header: this.$t('roster.main.stopPlanning'),
        centered: true,
        expanded: true,
      });
    },
    EscapeHandler($event) {
      if ($event.key === 'Escape') {
        this.showDetail = false;
      }
    },
    checkRosterFinish: function () {
      let resultToCheck = null;
      let view = this;
      Object.values(this.rosterResultMap).forEach(r => {
        if (resultToCheck == null && (r.state == 0 || r.state == 1)) {
          let currentTime = this.$helpers.getMomentTZ().add(-20, 'seconds');
          let rosterFinishTime = view.rosterResultCreationDateMap[r.id].clone().add(r.runtime+60,'seconds');
                if(currentTime  >= rosterFinishTime){
                    resultToCheck = r;
                }
            }
        });
        if(resultToCheck != null){
            console.log("found roster to check")
            this.loadRosterResult(resultToCheck.id)
            .then(response => {

                view.updateRosterState(response.data);
            }).catch(error => {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.loadingPlanError'));
            });
        }
        this.timerId = window.setTimeout(() => {this.checkRosterFinish();}, 20*1000);
    },
    onResizeWindow() {
        this.windowHeight = window.innerHeight;
    },
    onRowSelect(items){
        let view = this;

        if(items){
            view.selectedRosterId = items.id;
        } else {
            view.selectedRosterId = null;
        }
    },
    abortStage: function(){
        this.state = this.state-1;
    },
    reloadRosterResultListener: function(payload) {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && this.$store.state.rosterFromTo != null){
            this.showDetail = true;
            this.loadRosters();

        }
    },
    eventBusRosterResultCallback: function(payload) {
        let rosterResult = payload;
        this.updateRosterState(rosterResult);
        if(this.rosterResult.id == rosterResult.id){
            let view = this;
            this.rosterResult = rosterResult;

            let payload = { ids: []};
            var i;
            for (i = 0; i < this.rosterResult.data.roster.shiftList.length; i++) {
                let timeSlotId = this.rosterResult.data.roster.shiftList[i].timeSlotId
                let originalRequestId = this.rosterResult.data.roster.timeSlotMap[timeSlotId].originalRequestId
                if(this.rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId]){
                    let shiftId = this.rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId].originalId
                    payload.ids.push(shiftId);
                }

            }

            this.updateRosterShifts(payload, this.rosterResult)
            .catch(error => {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.loadingPlanError'));

            });
        }


    },
    loadRuleProfiles : function() {

        let url = '/api/sec/ruleprofile';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruleprofile');


         return this.axios({
             method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).catch(error =>
            Promise.reject({msg: this.$t('roster.main.loadingProfilesError')})
        )

    },
    updateRuleProfiles: function(data){
        let tRuleProfileMap = {};
        for(let i = 0; i<data.length; i++){
            tRuleProfileMap[data[i].id] = data[i];
        }
        this.ruleProfileMap = tRuleProfileMap;
    },
    loadRosters : function() {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined
            && this.$store.state.rosterFromTo != null && this.$store.state.rosterFromTo.from != null && this.$store.state.rosterFromTo.to != null){
            let view = this;
            this.rosterResult = {};
            this.selectedRosterId = null;
            let url = '/api/sec/employeeroster';

            let params = {
                storeId: this.$store.state.storeId,
                from: this.$helpers.getMomentFromValuesUTC(this.$store.state.rosterFromTo.year, this.$store.state.rosterFromTo.month, 1).format(),
                to: this.$helpers.getMomentFromValuesUTC(this.$store.state.rosterFromTo.year, this.$store.state.rosterFromTo.month, 1).endOf('month').format(),
            };

            this.axios({
                method: 'get',
                params: params,
                headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                url: url
            }).then(response => {
                let trosterOptions = [];


                let rosterResultMap = {};
                for (let i = 0; i < response.data.length; i++) {
                    rosterResultMap[response.data[i].id] = response.data[i];
                    let state = {val: response.data[i].state, label: ""};
                    if(response.data[i].state === 0 || response.data[i].state === 1){
                        state.label = this.$t('roster.main.inProgress');
                    }
                    if(response.data[i].state === 2 ){
                        state.label = this.$t('roster.main.finished');
                    }
                    if(response.data[i].state === 3 ){
                        state.label = this.$t('roster.main.failed');
                    }
                    if(response.data[i].state === 4 ){
                        state.label = this.$t('roster.main.stopped');
                    }

                    let tOption = { id: response.data[i].id, creationDate: this.$helpers.getMomentFromStringTZ(response.data[i].creationDate).format("DD.MM.YYYY HH:mm"),
                                    from: this.$helpers.getMomentFromStringTZ(response.data[i].from).format("DD.MMM"),
                                    to: this.$helpers.getMomentFromStringTZ(response.data[i].to).format("DD.MMM"), state: state, runtime: response.data[i].runtime,
                                    ruleProfileId: response.data[i].ruleProfileId,
                                    unassignedShifts: response.data[i].unassignedShifts,
                                    value: response.data[i]}
                    trosterOptions.push(tOption);
                }
                view.rosterResultMap = rosterResultMap;
                view.rosterOptions = trosterOptions;
                view.error = false;
                view.state = 1;
            }).catch(function (error) {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), this.$t('roster.main.loadingPlansError'));
            })
        }

    },
    updateRosterState: function(rosterResult) {

        const index = this.rosterOptions.findIndex(roster => roster.id === rosterResult.id);

        if(index >-1 && this.rosterResultMap[rosterResult.id]){
            this.rosterResultMap[rosterResult.id].state = rosterResult.state;
            this.rosterOptions[index].state.val = rosterResult.state;
            this.rosterResultMap[rosterResult.id].unassignedShifts = rosterResult.unassignedShifts;
            this.rosterOptions[index].unassignedShifts = rosterResult.unassignedShifts;

            if(rosterResult.state === 0 || rosterResult.state === 1){
                this.rosterOptions[index].state.label = this.$t('roster.main.inProgress');
            }
            if(rosterResult.state === 2 ){
                this.rosterOptions[index].state.label = this.$t('roster.main.finished');
            }
            if(rosterResult.state === 3 ){
                this.rosterOptions[index].state.label = this.$t('roster.main.failed');
            }
            if(rosterResult.state === 4 ){
                this.rosterOptions[index].state.label = this.$t('roster.main.stopped');
            }
        }


    },
    loadRosterResultPreview: function() {
        if(this.selectedRosterId != null && this.rosterResultMap[this.selectedRosterId] != null){
            let view = this;
            view.loading = true;
            this.loadRosterResult(this.selectedRosterId)
            .then(response => {

                this.rosterResult = response.data;
                view.updateRosterState(this.rosterResult);


                let payload = { ids: []}
                var i;
                for (i = 0; i < this.rosterResult.data.roster.shiftList.length; i++) {
                    let timeSlotId = this.rosterResult.data.roster.shiftList[i].timeSlotId
                    let originalRequestId = this.rosterResult.data.roster.timeSlotMap[timeSlotId].originalRequestId
                    if(this.rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId]){
                        let shiftId = this.rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId].originalId
                        payload.ids.push(shiftId);
                    }

                }
                view.loading = false;
                return this.updateRosterShifts(payload, this.rosterResult);
            }).catch(error => {
                view.loading = false;
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.loadingPlanError'));
            })
        }


    },
    updateRosterShifts: function(payload, rosterResult){
        let view = this;
        return this.loadShiftsAny(payload).then(response=>{
            let tShiftMap = {};
            for (let i = 0; i < response.data.length; i++) {
                tShiftMap[response.data[i].id] = response.data[i]
            }
            view.shiftMap = tShiftMap;
            let payload = { ids: []}

            for (var p in rosterResult.data.roster.employeeMap) {
                if (rosterResult.data.roster.employeeMap.hasOwnProperty(p)) {
                    let resultEmployeeId = rosterResult.data.roster.employeeMap[p].id;
                    let shiftId = rosterResult.data.roster.customEntityMapping.employeeMapping[resultEmployeeId].originalId
                    payload.ids.push(shiftId);
                }

            }
            return this.loadEmployeesAny(payload);
        }).then(response=>{

            let tEmployeeMap = {};
            for (let i = 0; i < response.data.length; i++) {
               tEmployeeMap[response.data[i].id] = response.data[i]
            }
            view.employeeMap = tEmployeeMap;

            //link employees in roster result to shifts map and create array for display table
            let tShifts = [];
            let updateableShiftIds = [];
            for (let i = 0; i < rosterResult.data.roster.shiftList.length; i++) {
                let timeSlotId = rosterResult.data.roster.shiftList[i].timeSlotId
                let originalRequestId = rosterResult.data.roster.timeSlotMap[timeSlotId].originalRequestId
                if(rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId]){
                    let shiftId = rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId].originalId
                    if(view.shiftMap[shiftId] != null && !view.shiftMap[shiftId].published){
                        let resultEmployeeId = rosterResult.data.roster.shiftList[i].employeeId;
                        if(view.rosterResult.data.roster.customEntityMapping.employeeMapping[resultEmployeeId] != null){
                            view.shiftMap[shiftId].employeeId = rosterResult.data.roster.customEntityMapping.employeeMapping[resultEmployeeId].originalId;
                            //use the time from autoscheduler not just employee assignment
                            /*let fromMoment = view.$helpers.getMomentFromStringTZ(view.shiftMap[shiftId].from);
                            let toMoment = view.$helpers.getMomentFromStringTZ(view.shiftMap[shiftId].to);
                            let timeSlotFrom = rosterResult.data.roster.timeSlotMap[timeSlotId].startDateTime;
                            let timeSlotTo = rosterResult.data.roster.timeSlotMap[timeSlotId].endDateTime;
                            fromMoment.date(timeSlotFrom.day).month(timeSlotFrom.month-1).year(timeSlotFrom.year).hour(timeSlotFrom.hour).minute(timeSlotFrom.minute)
                            toMoment.date(timeSlotTo.day).month(timeSlotTo.month-1).year(timeSlotTo.year).hour(timeSlotTo.hour).minute(timeSlotTo.minute)
                            view.shiftMap[shiftId].from = fromMoment.format();
                            view.shiftMap[shiftId].to = toMoment.format(); */
                        } else {
                            view.shiftMap[shiftId].employeeId = null;
                        }
                        if(!rosterResult.data.roster.shiftList[i].lockedByUser){
                            updateableShiftIds.push(shiftId);
                        }

                    }
                }

            }
            for(let shiftId in view.shiftMap){
                if(!view.shiftMap[shiftId].published && !view.shiftMap[shiftId].pinned){
                    tShifts.push(view.shiftMap[shiftId]);
                }

            }
            view.updateableShiftIds = updateableShiftIds;

            VueEventBus.$emit("preview-autoroster-result", tShifts);
            view.error = false;

        });
    },
    applyRosterResult : function() {
        let view = this;
        
        let url = '/api/sec/planshift/assign/multi';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/assign/multi');

        let payload =  {
            requests: [],
        }

        for(let i = 0; i< this.updateableShiftIds.length; i++){
            let shift = this.shiftMap[this.updateableShiftIds[i]];
            let request = {
                id: shift.id,
                employeeId: shift.employeeId,
                setBreak: false,
            }
            if(shift.breakFrom == null){
                let from = this.$helpers.getMomentFromStringTZ(shift.from);
                let to = this.$helpers.getMomentFromStringTZ(shift.to);
                        
                let employeeId = shift.employeeId;
                let breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(employeeId != null ? view.$helpers.isUnderage(view.employeeMap[employeeId].dob, view.$parent.startOfMonth, true) : false, from, to, view.storeSettings);
                request.breakFrom = null;
                request.breakValue = breakValue;
                request.setBreak = true;
            }
            payload.requests.push(request);
        }

        if(payload.requests.length > 0){
            view.loading = true;
            this.axios({
                method: 'put',
                headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                url: url,
                data: payload
            }).then(response => {
                view.loading = false;
                view.showDetail = false;
                VueEventBus.$emit('apply-autoroster-result');
            }).catch(function (error) {
                view.loading = false;
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.editShiftsError'));
            })
        } else {
            VueEventBus.$emit('apply-autoroster-result');
        }
    },
    loadRosterResult: function(id) {
        let url = '/api/sec/employeeroster';

        let params = {
            storeId: this.$store.state.storeId,
            id: id,
        }


        return this.axios({
            method: 'get',
            params: params,
            headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
            url: url
        }).catch(error =>
            Promise.reject({msg: this.$t('roster.main.loadResultsError')})
        )
    },
    openModal: function(id, modal){
        this.selectedRosterId = id;
        this.showModal(modal)
    },
    deleteRoster: function() {
      let url = '/api/sec/employeeroster';
      let view = this;
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeroster');
      url = this.$helpers.appendParam("id", this.selectedRosterId, url, '/api/sec/employeeroster');

      this.axios({
        method: 'delete',
        headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
        url: url
      }).then(response => {
        const index = view.rosterOptions.findIndex(roster => roster.id === view.selectedRosterId)

        if (~index) {
            view.rosterOptions.splice(index, 1);
        }

      }).catch(error => {
            console.log(error);
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.deletePlanError'));
      })
    },
    stopRoster: function() {
      let url = '/api/sec/employeeroster/stop';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeroster/stop');
      url = this.$helpers.appendParam("id", this.selectedRosterId, url, '/api/sec/employeeroster/stop');
      let view = this;
      this.axios({
        method: 'put',
        headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
        url: url
      }).then(response => {
        const index = view.rosterOptions.findIndex(roster => roster.id === view.selectedRosterId)

        view.rosterOptions[index].state.val = 4;
        view.rosterOptions[index].state.label = this.$t('roster.main.stopped');
        let rosterResult = view.rosterResultMap[view.selectedRosterId];
        rosterResult.state = 4;
        view.$set(view.rosterResultMap, view.selectedRosterId, rosterResult);

      }).catch(error => {
            console.log(error);
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.stopPlanError'));
      })
    },
    loadSpotsAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/spot/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot/any');


            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error =>
                Promise.reject({msg: "Fehler beim Laden der Positionen"})
            )
        }
    },
    loadShiftsAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/planshift/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/any');


            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error =>
                Promise.reject({msg: this.$t('roster.main.loadingShiftsError')})
            )
        }
    },
    loadEmployeesAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employee/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/any');

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error =>
                Promise.reject({msg: this.$t('roster.main.loadingEmployeeError')})
            )
        }
    },
    extractDate: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split = str.split("T");
            return split[0];
        } else {
            return null;
        }
    },
    extractTime: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split1 = str.split("T");
            let split2 = split1[1].split(":")
            return split2[0]+":"+split2[1];
        } else {
            return null;
        }
    },
    getMinuteDiff: function(dt2, dt1) {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    },
  }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>
.main-div {
    display: inline-block;
    position: fixed;
}
.cog-icon {
    color: #404040;
}
.bottom-left {
    z-index: 100;
    top: auto;
    left: auto;
    bottom: 58px;
    right: 28px;
}

.bottom-left.with-chat {
    bottom: 126px;
}

.middle-left {
    z-index: 100;
    top: auto;
    left: auto;
    bottom: 416px;
    right: 28px;
}
.top-left {
    z-index: 100;
    width: calc(50% - 9px);
    top: 143px;
    left: auto;
    bottom: auto;
    right: 18px;
}

.square-button {
  height: 52px !important;
  width: 52px !important;
  padding: 0;
  background: var(--contrast-3);
  border-color: var(--contrast-3);
}

</style>
